import React from "react";

export default function SocialMediaElements({ icon, url, style }) {
  return (
    <div className={`${style} mr-7`}>
      <a className="" href={url} target="_blank">
        <img src={icon} />
      </a>
    </div>
  );
}
